import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { dashboardForRole } from '@/lib/routes';
export const ProtectedRoute = ({ element, allowed }) => {
    const user = useAuthStore((s) => s.user);
    if (!user)
        return _jsx(Navigate, { to: "/login", replace: true });
    if (!allowed.includes(user.role))
        return _jsx(Navigate, { to: dashboardForRole(user.role), replace: true });
    return element;
};
